// src/global-fetch-patch.ts
// EARLY PATCH disabled - using server proxy instead of direct AWS calls
console.log('[GLOBAL FETCH PATCH] EARLY PATCH disabled - using server proxy for API calls');